{
    "name": "brewers-angular",
    "version": "26.901.1",
    "scripts": {
        "ng": "ng",
        "prestart": "pnpm install",
        "start": "ng serve --port 5153 -o",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^21.1.4",
        "@angular/common": "^21.1.4",
        "@angular/compiler": "^21.1.4",
        "@angular/core": "^21.1.4",
        "@angular/forms": "^21.1.4",
        "@angular/platform-browser": "^21.1.4",
        "@angular/platform-browser-dynamic": "^21.1.4",
        "@angular/router": "^21.1.4",
        "bootstrap": "^5.3.8",
        "breeze-client": "^2.1.5",
        "devextreme": "25.2.5",
        "devextreme-angular": "25.2.5",
        "exceljs": "^4.4.0",
        "file-saver": "^2.0.5",
        "font-awesome": "^4.7.0",
        "jquery": "^3.7.1",
        "jquery-slimscroll": "^1.3.8",
        "lodash": "^4.17.21",
        "metismenu": "^3.0.7",
        "moment": "^2.30.1",
        "ngx-bootstrap": "^21.0.1",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^21.1.4",
        "@angular/cli": "^21.1.4",
        "@angular/compiler-cli": "^21.1.4",
        "@types/file-saver": "^2.0.7",
        "@types/jasmine": "~5.1.0",
        "@types/lodash": "^4.17.6",
        "breeze-entity-generator": "1.4.1",
        "typescript": "~5.9.3"
    }
}
